<template>
	<JBox>
		<!-- Header -->
		<CLayoutEditorHeader
			:isLoading="isLoading"
			headline="App Config"
			saveButton="Save"
			@back:click="$router.back()"
			@save:click="upsertConfig"
		/>

		<!-- Editor -->
		<JBox class="s-max-w-6xl s-mx-auto">
			<JsonEditor v-model="configAsString" />
		</JBox>

		<!-- Error Message -->
		<JBox class="s-w-full s-fixed s-bottom-0 s-left-0 s-p-4 s-bg-red-200 s-text-red-700" v-if="errorMessage">
			{{ errorMessage }}
		</JBox>
	</JBox>
</template>

<script>
import api from "@/api/api.js"
import JsonEditor from "../components/JsonEditor"
import { query, mutation } from "../api/queries"
import { parseAppConfigProperties, stringifyAppConfigProperties } from "../utils"

export default {
	components: { JsonEditor },
	props: {
		// From router
		appId: {
			type: String
		}
	},

	data() {
		return {
			isLoading: false,
			errorMessage: "",

			configAsString: "",
			originalConfigAsString: ""
		}
	},

	computed: {
		hasConfigChanged() {
			return this.configAsString !== this.originalConfigAsString
		}
	},

	methods: {
		async fetchConfig() {
			this.errorMessage = ""
			this.isLoading = true
			const res = await api({ query: query.cmsConfig, variables: { where: { appId: this.appId } } })
			this.isLoading = false

			let config = parseAppConfigProperties(res?.data?.cmsConfigs?.[0] ?? {})
			config = JSON.stringify(config, null, 2)
			this.configAsString = config
			this.originalConfigAsString = config
		},

		async upsertConfig() {
			if (this.isLoading) return
			this.errorMessage = ""

			let config
			try {
				config = stringifyAppConfigProperties(JSON.parse(this.configAsString))
			} catch (e) {
				this.errorMessage = `Oops, something wrong with the JSON. ${e}`
			}

			this.isLoading = true
			const res = await api({
				query: mutation.upsertCmsConfig,
				variables: { appId: this.appId, config }
			})
			this.isLoading = false

			if (res?.data?.upsertCmsConfig?.status !== "success") {
				this.errorMessage = res?.data?.upsertCmsConfig?.errors?.[0] || res?.errors?.[0]?.message || "There was an error."
				return
			}

			this.originalConfigAsString = this.configAsString
		},

		preventBrowserReload(event) {
			event.preventDefault()
			event.returnValue = "Are you sure you want to leave?" // Older browsers supported custom message
			return ""
		}
	},

	mounted() {
		this.fetchConfig()

		// Prevent browser refresh
		// window.addEventListener("beforeunload", this.preventBrowserReload)
	},

	beforeDestroy() {
		// window.removeEventListener("beforeunload", this.preventBrowserReload)
	},

	// Prevent accidental browser back button
	beforeRouteLeave(to, from, next) {
		// When no change
		if (!this.hasConfigChanged) {
			next()
			return
		}

		const answer = window.confirm("Do you really want to leave? you have unsaved changes!")
		if (answer) next()
		else next(false)
	}
}
</script>
